// extracted by mini-css-extract-plugin
module.exports = {"popupEnter":"popups_popupEnter__nM6hj","popupEnterActive":"popups_popupEnterActive__0YadV","popupExit":"popups_popupExit__TCqid","popupExitActive":"popups_popupExitActive__Bruiu"};